import React, {Component} from 'react';
import { List, InputItem, Button, Toast } from 'antd-mobile';
import Blank from '../components/Blank';
import LoadingPlaceholder from '../components/LoadingPlaceholder';
import TipPlaceholder from '../components/TipPlaceholder';
import ProfileView from '../components/ProfileView';
import DataFetcher from '../utils/DataFetcher';
import CommonUtils from '../utils/CommonUtils';
import BrandUtils from '../utils/BrandUtils';
import Constants from '../utils/Constants';
import { createForm } from 'rc-form';
import iconAvatar from '../medias/logo.jpg';
import '../styles/UserCoupon.css';

const history = require("history").createHashHistory()

class UserCoupon extends Component {
    constructor(props) {
        super(props);

        this.state = {
            status: 'loading',
            userProfile: {},
            couponSummary: {
                toExchangeCount: 0,
                exchangedCount: 0
            },
            enableGrab: true
        }
    }

    componentDidMount() {
        this.loadInitData()
    }

    loadInitData = () => {
        this.loadProfile()
        this.loadCouponSummary()
    }

    loadCouponSummary = () => {
        DataFetcher.userCouponSummary({}, {
            success: (resp) => {
                this.setState({
                    couponSummary: resp.data
                })
            }
        })
    }


    loadProfile = () => {
        DataFetcher.profile({
        }, { 
            success: (resp) => {
                this.setState({
                    status: 'success',
                    userProfile: resp.data
                })
            }
        })
    }

    handleGrabClick = () => {
        if(!this.state.enableGrab) {
            return
        }

        this.setState({
            enableGrab: false
        })
        this.props.form.validateFields((error, fieldsValue) => {
            const params = {}
            for(let prop in fieldsValue) {
                if(prop.indexOf('grab_') !== 0) {
                    continue
                }
                params[prop.substring('grab_'.length)] = fieldsValue[prop]                
            }

            DataFetcher.grabCouponByCode(params, {
                success: (resp) => {
                    Toast.info('兑换成功')
                    history.push('/user/coupon_usage')
                },
                completed: () => {
                    this.setState({
                        enableGrab: true
                    })
                }
            })
        })
    }

    handleCouponUsage = () => {
        history.push('/user/coupon_usage')
    }

    generateHeaderView() {
        const { userProfile } = this.state;
        let brandName = BrandUtils.getCachedBrandName()
        if(CommonUtils.isEmpty(brandName)) {
            brandName = Constants.Strings.APP_NAME
        }

        return (
            <div className="section-header">
                <div className="container-left">
                    <div className="fl wrapper-avatar">
                        <img src={userProfile.avatar?userProfile.avatar:iconAvatar} alt=""/>
                    </div>
                    <div className="fl wrapper-basic">
                        <div className="name word-ellipsis">{CommonUtils.isEmpty(userProfile.nickName)?'游客':userProfile.nickName}</div>
                        <div className="brand word-ellipsis">{brandName}</div>
                    </div>
                </div>
                <div className='container-right'>
                    <button className="btn-coupon-usage" onClick={this.handleCouponUsage}>我的卡券</button>
                </div>
            </div>
        )
    }

    generateProfileView() {
        const { userProfile, couponSummary } = this.state;
        let data = []
        data.push({label: '可用卡券', value: couponSummary.toExchangeCount})
        data.push({label: '已用卡券', value: couponSummary.exchangedCount})
        data.push({label: '游戏积分', value: userProfile.point})

        return <ProfileView data={data}/>
    }

    generateGrabView = () => {
        const { getFieldProps } = this.props.form;
        const { enableGrab } = this.state

        return (
            <div className="section-grab">
                <div className="title">
                    <i className='iconfont icon-shouye1' style={{fontSize:20}}></i>
                    <span> 优惠券兑换</span>
                    <span className="sub"></span>
                </div>
                <div className="wrapper-content">
                    <List>
                        <InputItem style={{textAlign: 'center'}} placeholder='请输入券码' {...getFieldProps('grab_couponCode', {})}></InputItem>
                        <List.Item>
                            <Button type="primary" onClick={this.handleGrabClick} disabled={!enableGrab}>马上兑换</Button>
                        </List.Item>
                    </List>
                </div>
            </div>
        )
    }

    doRenderView() {
        return (
            <div className="page-user-coupon">
                {this.generateHeaderView()}
                <Blank/>
                {this.generateProfileView()}
                <Blank/>
                {this.generateGrabView()}
            </div>
        )
    }

    render() {
        const {status} = this.state;

        if(status === 'loading') {
            return <LoadingPlaceholder/>;
        } else if (status === 'noauth') {
            return <TipPlaceholder firstTip={Constants.Strings.APP_NAME} secondTip={'请重新扫码'}/>;
        } else {
            return this.doRenderView()
        }
    }
}

export default createForm()(UserCoupon);


// WEBPACK FOOTER //
// ./src/modules/UserCoupon.js